export default {
  // Common
  brandName: 'SmartCrafter',
  github: 'GitHub',

  // Navigation
  nav: {
    features: '功能',
    interface: '界面',
    workflow: '工作流程',
  },

  // Hero
  hero: {
    badge: '结构化技能系统',
    heading: '精心雕琢',
    headingHighlight: '你的知识',
    description: '一款桌面应用程序，用于管理、组织和导出结构化知识模块，兼具工程的精准与工艺的艺术性。',
    exploreFeatures: '探索功能',
    viewOnGithub: '查看 GitHub',
  },

  // Features
  features: {
    sectionLabel: '功能特性',
    title: '精准打造',
    description: '每个功能都经过精心设计，帮助你以应有的关怀和注意力来组织知识。',

    skillManagement: {
      title: '技能管理',
      description: '创建、编辑和组织知识模块，支持分层文件夹结构和丰富的元数据。',
    },
    exportSystem: {
      title: '导出系统',
      description: '为不同目标配置多个导出规则，支持基于路径的过滤和孤立检测。',
    },
    importCapabilities: {
      title: '导入功能',
      description: '从本地文件系统目录导入技能，从现有内容构建知识库。',
    },
    markdownEditor: {
      title: 'Markdown 编辑器',
      description: '实时 Markdown 预览，语法高亮，以及干净、无干扰的写作环境。',
    },
    threePanelInterface: {
      title: '三面板界面',
      description: '高效的工作流程，项目树、编辑器和技能面板完美协作。',
    },
    claudeIntegration: {
      title: 'Claude 集成',
      description: '与 Claude AI 无缝集成，实现智能技能生成和管理辅助。',
    },
  },

  // Interface Showcase
  interface: {
    sectionLabel: '界面',
    title: '流畅的工作空间',
    description: '三面板界面将你需要的一切触手可及。',
    windowTitle: 'SmartCrafter',
    projectTree: '项目树',
    editor: '编辑器',
    skillSet: '技能集',
    realTimePreview: '实时预览',
    syntaxHighlighting: '语法高亮',
  },

  // Workflow
  workflow: {
    sectionLabel: '工作流程',
    title: '从混乱到清晰',
    description: '简单而强大的工作流程，彻底改变你的知识管理方式。',

    step1: {
      number: '01',
      title: '导入或创建',
      description: '从文件系统导入现有技能，或从头开始创建新技能。',
    },
    step2: {
      number: '02',
      title: '组织与结构化',
      description: '将技能排列在分层文件夹中，配备丰富的元数据和分类。',
    },
    step3: {
      number: '03',
      title: '导出与部署',
      description: '配置导出规则并将技能部署到指定位置。',
    },

    useCaseLabel: '用例',
    aiSkillLibraries: {
      title: 'AI 技能库',
      description: '为 AI 代理和助手构建和维护结构化的技能库。',
    },
    documentationManagement: {
      title: '文档管理',
      description: '使用分层结构和元数据组织项目文档。',
    },
  },

  // Footer
  footer: {
    copyright: '© 2025 SmartCrafter. 精心打造。',
  },

  // Language Switcher
  language: {
    en: 'EN',
    zh: '中文',
  },
}
